/**
 * Appends UTM query parameters to a Calendly URL for attribution tracking.
 *
 * @param calendlyUrl - The base Calendly URL
 * @param campaign   - e.g. "Floating Button" or "Contentful Module"
 * @param pageUrl    - The page the user is on (used as utm_content)
 */
export function appendCalendlyUtm(
  calendlyUrl: string,
  campaign: string,
  pageUrl: string,
): string {
  try {
    const url = new URL(calendlyUrl);
    url.searchParams.set("utm_source", "yardzen.com");
    url.searchParams.set("utm_medium", "website");
    url.searchParams.set("utm_campaign", campaign);
    url.searchParams.set("utm_term", "empty");
    url.searchParams.set("utm_content", pageUrl);
    return url.toString();
  } catch {
    return calendlyUrl;
  }
}

export function isCalendlyUrl(url?: string): url is string {
  return !!url && /^https:\/\/(www\.)?calendly\.com\//.test(url);
}
